import IframeResizer from "iframe-resizer-react";
import { useEffect, useState } from "react";
export type IframeWrapperAttr = {
  className?: string;
};

export type IframeProps = {
  src: string;
  height?: string;
  width?: string;
  title?: string;
  className?: string;
  allowFullScreen?: boolean;
  addWrapper?: boolean;
  wrapperAttr?: IframeWrapperAttr;
};

export default function Iframe({
  src,
  height = "642",
  width = "620",
  title = "#NoTapis",
  className,
  allowFullScreen = false,
  addWrapper = false,
  wrapperAttr = {},
}: IframeProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const iframe = (
    <>
      <div className="justify-center">
        <IframeResizer
          className={className}
          src={src}
          checkOrigin={false}
          heightCalculationMethod={isMobile ? "bodyScroll" : "max"}
          title={title}
          allowFullScreen={allowFullScreen}
          scrolling="yes"
          style={{
            width: width,
            minWidth: isMobile ? "95%" : "100%",
            border: "none",
            minHeight: isMobile ? "1024px" : height + "px",
          }}
        />
      </div>
    </>
  );

  return addWrapper ? (
    <div className={wrapperAttr.className}>{iframe}</div>
  ) : (
    iframe
  );
}
